var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Picker Icon",
    d: "M1.59375 18C1.15104 18 0.77474 17.8511 0.464844 17.5532C0.154948 17.2553 0 16.8936 0 16.4681V6.51064C0 6.27234 0.057552 6.04255 0.172656 5.82128C0.28776 5.6 0.442708 5.42128 0.6375 5.28511L7.54375 0.306383C7.68542 0.204255 7.83594 0.12766 7.99531 0.0765958C8.15469 0.025532 8.32292 0 8.5 0C8.67708 0 8.84531 0.025532 9.00469 0.0765958C9.16406 0.12766 9.31458 0.204255 9.45625 0.306383L16.3625 5.28511C16.5573 5.42128 16.7122 5.6 16.8273 5.82128C16.9424 6.04255 17 6.27234 17 6.51064V16.4681C17 16.8936 16.8451 17.2553 16.5352 17.5532C16.2253 17.8511 15.849 18 15.4062 18H10.625V10.8511H6.375V18H1.59375Z",
    fill: "#2A7F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseImg);
export default __webpack_public_path__ + "static/media/houseImg.409de10e01b354db6b816b4c6a615cfd.svg";
export { ForwardRef as ReactComponent };